import $ from 'jquery';
import { main } from './main';
import { sub } from './sub';
import { slide } from './slide';

let DEV = window.DEV || {};
DEV = (function ($) {
	'use strict';
	const common = {
		motion: function () {
			$('.is-motion').each(function () {
				const top = $(this).offset().top;
				const scrollTop = $(window).scrollTop();
				const windowHeight = $(window).height();
				const documentHeight = $(document).height();
				let timing = $('.section-index').length === 0 ? 0.2 : 0.1;

				if (scrollTop > top - (windowHeight - windowHeight * timing)) {
					$(this).addClass('is-motion-on');
				} else if (scrollTop + windowHeight + 2 >= documentHeight) {
					$(this).addClass('is-motion-on');
				} else if (scrollTop < top) {
					$(this).removeClass('is-motion-on');
				}
			});
		},
		imageBackground: () => {
			const item = $('.images-change');
			item.each(function () {
				const url = window.innerWidth > 768 ? $(this).data('pc') : $(this).data('mobile');
				$(this).css('background-image', `url(${url})`);
			});
		},
		btnTop: () => {
			const top = $('#top_btn');
			top.on('click', function () {
				$('html').animate({ scrollTop: 0 }, 500);
			});
		},
		btnTopHide: () => {
			const top = $('#top_btn');
			const scrollTop = $(window).scrollTop();
			if (scrollTop < 100) {
				top.addClass('hidden');
			} else {
				top.removeClass('hidden');
			}
		},
		localeActive: () => {
			const button = $('.nav-lang a');
			const currentURL = window.location.href;
			if (currentURL.includes('/en')) {
				button.filter('.en').addClass('active');
			} else {
				button.filter('.kr').addClass('active');
			}
		},

		//렌딩 팝업
		landingPopup: () => {
			const closeButtons = document.querySelectorAll('.landing_popup_close_btn');
			closeButtons.forEach((button) => {
				button.addEventListener('click', function () {
					const popupContainer = this.closest('.landing_popup_container');
					popupContainer.classList.add('hidden');
				});
			});

			const agreeOk1 = document.getElementById('agree_ok1');
			const agreeOk2 = document.getElementById('agree_ok2');
			const agreeOk3 = document.getElementById('agree_ok3');

			if (agreeOk1) {
				let agreeOk1Checked = agreeOk1.checked;

				agreeOk1.addEventListener('change', function () {
					agreeOk1Checked = this.checked;
				});
			}

			if (agreeOk2) {
				let agreeOk2Checked = agreeOk2.checked;

				agreeOk2.addEventListener('change', function () {
					agreeOk2Checked = this.checked;
				});
			}

			if (agreeOk3) {
				let agreeOk3Checked = agreeOk3.checked;

				agreeOk3.addEventListener('change', function () {
					agreeOk3Checked = this.checked;
				});
			}
		},
		init: function () {
			common.motion();
			common.imageBackground();
			common.btnTop();
			common.btnTopHide();
			common.localeActive();
			common.landingPopup();

			$(window).on('scroll', function () {
				common.motion();
				common.btnTopHide();
			});

			// 리사이징 디바운스
			let resizeTimer;
			$(window).on('resize', function () {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function () {
					common.imageBackground();
				}, 200);
			});
		},
	};

	$(function () {
		common.init();
		main.init();
		sub.init();
		slide.init();
	});

	return {};
})($);
